import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { DEFAULT_ORGANIZATION_MEMBERS_LIMIT, DEFAULT_ORGANIZATION_MEMBERS_PAGE, } from '#pplx/frontend/apps/ask/queries/enterprise-queries/types.js';
import { normalizeEnterpriseMember } from '#pplx/frontend/user-info/enterpriseResponse.js';
import { enterpriseClient } from '#pplx_generated/typespec/rest/enterprise/client.js';
export const getOrganizationMembers = async ({ page = DEFAULT_ORGANIZATION_MEMBERS_PAGE, limit = DEFAULT_ORGANIZATION_MEMBERS_LIMIT, emailFilter, role, isScimManaged, inCometAllowlist, inAsiAllowlist, subscriptionTier, sortBy, sortDirection, memberType, revisionToken, reason, headers, }) => {
    const { data, error, response } = await enterpriseClient.GET('/rest/enterprise/user/organization/members', reason, {
        params: {
            query: {
                page,
                limit,
                'email-filter': emailFilter ?? null,
                role: role ?? null,
                'is-scim-managed': isScimManaged ?? null,
                'in-comet-allowlist': inCometAllowlist ?? null,
                'in-asi-allowlist': inAsiAllowlist ?? null,
                'subscription-tier': subscriptionTier ?? null,
                'sort-by': sortBy ?? null,
                'sort-direction': sortDirection ?? null,
                'member-type': memberType ?? null,
                revision_token: revisionToken ?? null,
            },
        },
        timeoutMs: getQueryTimeoutMs({ productionMs: 5000 }),
        headers,
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            cause: error,
            status: response.status ?? 0,
        });
    }
    // TODO(ENT-6348): Remove the legacy input alias in the final cleanup.
    return {
        ...data,
        member_list: data.member_list.map(normalizeEnterpriseMember),
    };
};
//# sourceMappingURL=getOrganizationMembers.js.map